import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardRibbon } from '../../models/card';

enum RibbonCssClassesByProductGroup {
  AXQ = 'ribbon--amex',
  CFHR = 'ribbon--centurion-fine-hotels-resorts',
  FHR = 'ribbon--fine-hotels-resorts',
  GHC = 'ribbon--global-hotel-collection',
  TENDC = 'ribbon--global-hotel-collection',
  Installments = 'ribbon--instalments',
}

enum RibbonCssClassesByOfferType {
  Exclusive = 'ribbon--exclusive',
  MemberFavourite = 'ribbon--member-favourite',
  MemberBenefitPriceless = 'ribbon--member-benefit-priceless',
}

enum RibbonCssClassesByEntertainmentEventType {
  ConciergeSelection = 'ribbon--concierge-selection',
  PremiumAccess = 'ribbon--premium-access',
  ExclusiveOffer = 'ribbon--exclusive-offer',
  Presale = 'ribbon--presale',
  ExclusivePresale = 'ribbon--exclusive-presale',
}

@Component({
  selector: 'ten-card-ribbon',
  templateUrl: './card-ribbon.component.html',
  styleUrls: ['./card-ribbon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgClass, TranslateModule],
})
export class CardRibbonComponent implements OnInit {
  @Input() public ribbonData: CardRibbon;

  public ribbonClass: string;

  private ribbonCssClassesByProductGroup = RibbonCssClassesByProductGroup;
  private ribbonCssClassesByOfferType = RibbonCssClassesByOfferType;
  private ribbonCssClassesByEntertainmentEventType = RibbonCssClassesByEntertainmentEventType;

  public ngOnInit(): void {
    this.ribbonClass = this.extractRibbonClassFromRibbonData();
  }

  private extractRibbonClassFromRibbonData(): string {
    let value;

    value = this.ribbonCssClassesByProductGroup[this.ribbonData?.productGroup?.toString()];
    if (value) {
      return value;
    }

    value = this.ribbonCssClassesByOfferType[this.ribbonData?.type?.toString()];
    if (value) {
      return value;
    }

    value = this.ribbonCssClassesByEntertainmentEventType[this.ribbonData?.type?.toString()];
    if (value) {
      return value;
    }

    return 'ribbon--default';
  }
}
